import { useContext, useMemo } from "react";
import UserContext, { User_Type } from "./UserContext";

interface Props {
    children: any;
    ops: string[];
    fallback?: JSX.Element | null;
    strategy?: "some" | "all";
}

export function MultiPermissionAuthorize({
    children,
    ops,
    fallback = null,
    strategy = "all",
}: Props) {
    const { user } = useContext(UserContext);
    const isAuthorizeUser = useMultipermissionAuthorize(ops, strategy);

    if (isAuthorizeUser || user?.user_type === User_Type.Superadmin) {
        return children;
    } else {
        return fallback;
    }
}

export default MultiPermissionAuthorize;

export function useMultipermissionAuthorize(
    ops: Props["ops"],
    strategy: Props["strategy"] = "all"
) {
    const { user } = useContext(UserContext);

    const permissions = useMemo(() => {
        if (!user) return [];

        if (user.user_type === User_Type.Superadmin) return [];

        return user.role.permissions.map((item) => item.op.name);
    }, [user?.username]);

    if (
        permissions
            ? strategy === "all"
                ? ops.every((op) => permissions.includes(op))
                : ops.some((op) => permissions.includes(op))
            : true
    ) {
        return true;
    } else {
        return false;
    }
}
